/* This is generated code, don't alter */
var IfcEventTriggerTypeEnum;
(function (IfcEventTriggerTypeEnum) {
    IfcEventTriggerTypeEnum[IfcEventTriggerTypeEnum["EVENTRULE"] = 0] = "EVENTRULE";
    IfcEventTriggerTypeEnum[IfcEventTriggerTypeEnum["EVENTMESSAGE"] = 1] = "EVENTMESSAGE";
    IfcEventTriggerTypeEnum[IfcEventTriggerTypeEnum["EVENTTIME"] = 2] = "EVENTTIME";
    IfcEventTriggerTypeEnum[IfcEventTriggerTypeEnum["EVENTCOMPLEX"] = 3] = "EVENTCOMPLEX";
    IfcEventTriggerTypeEnum[IfcEventTriggerTypeEnum["USERDEFINED"] = 4] = "USERDEFINED";
    IfcEventTriggerTypeEnum[IfcEventTriggerTypeEnum["NOTDEFINED"] = 5] = "NOTDEFINED";
})(IfcEventTriggerTypeEnum || (IfcEventTriggerTypeEnum = {}));
const IfcEventTriggerTypeEnumCount = 6;
export { IfcEventTriggerTypeEnum, IfcEventTriggerTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcEventTriggerTypeEnum = new Int32Array([33]);
let prefixSumAddressIfcEventTriggerTypeEnum = new Uint32Array([0, 11, 22, 35, 49, 61, 75]);
let slotMapIfcEventTriggerTypeEnum = new Int32Array([2, 0, 4, 1, 5, 3]);
let encodedDataIfcEventTriggerTypeEnum = (new TextEncoder()).encode(".EVENTTIME..EVENTRULE..USERDEFINED..EVENTMESSAGE..NOTDEFINED..EVENTCOMPLEX.");
let IfcEventTriggerTypeEnumSearch = new MinimalPerfectHash(gMapIfcEventTriggerTypeEnum, prefixSumAddressIfcEventTriggerTypeEnum, slotMapIfcEventTriggerTypeEnum, encodedDataIfcEventTriggerTypeEnum);
export { IfcEventTriggerTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcEventTriggerTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcEventTriggerTypeEnumSearch, input, cursor, endCursor);
}
